export default "__VITE_ASSET__B_PZyD_w__"